export const catalogEndpoints = {
  search: (query: string) => `/catalogo/ricerca/${encodeURIComponent(query)}`,
};
